import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTwFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_52845)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1378 41.3797H0.862108C0.386034 41.3797 0 40.9937 0 40.5176V9.4832C0 9.00713 0.386034 8.62109 0.862108 8.62109H49.1379C49.614 8.62109 50 9.00713 50 9.4832V40.5176C49.9999 40.9938 49.6139 41.3797 49.1378 41.3797Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.862108 8.62109H24.1379C24.614 8.62109 25.0001 9.00713 25.0001 9.4832V24.1383C25.0001 24.6144 24.614 25.0005 24.1379 25.0005H0.862108C0.386034 25.0004 0 24.6143 0 24.1383V9.4831C0 9.00703 0.386034 8.62109 0.862108 8.62109Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.41372 16.8108C9.41372 15.959 9.75883 15.1879 10.3168 14.6296L7.73149 13.8901C7.5814 13.8472 7.47388 14.0335 7.58598 14.142L9.52065 16.0126L6.90991 16.6654C6.75854 16.7032 6.75854 16.9184 6.90991 16.9563L9.52065 17.609L7.58598 19.4796C7.47378 19.5881 7.5814 19.7744 7.73149 19.7316L10.3168 18.992C9.75883 18.4336 9.41372 17.6625 9.41372 16.8108Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.3182 14.628C10.8765 14.07 11.6476 13.7248 12.4994 13.7248C13.3511 13.7248 14.1222 14.07 14.6805 14.628L15.4201 12.0426C15.4629 11.8925 15.2766 11.785 15.1681 11.8971L13.2975 13.8317L12.6448 11.2209C12.607 11.0696 12.3917 11.0696 12.3538 11.2209L11.7011 13.8317L9.83051 11.8971C9.72201 11.7849 9.53569 11.8925 9.57856 12.0426L10.3182 14.628Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6809 18.9932C14.1226 19.5512 13.3515 19.8963 12.4997 19.8963C11.648 19.8963 10.8769 19.5512 10.3186 18.9932L9.57905 21.5785C9.53618 21.7286 9.7225 21.8361 9.831 21.724L11.7016 19.7895L12.3543 22.4002C12.3921 22.5516 12.6074 22.5516 12.6453 22.4002L13.298 19.7895L15.1686 21.724C15.2771 21.8362 15.4634 21.7286 15.4205 21.5785L14.6809 18.9932Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.0892 16.6654L15.4784 16.0126L17.413 14.142C17.5252 14.0335 17.4176 13.8472 17.2675 13.8901L14.6821 14.6296C15.2401 15.1879 15.5853 15.959 15.5853 16.8108C15.5853 17.6625 15.2401 18.4336 14.6821 18.9919L17.2675 19.7315C17.4176 19.7743 17.5251 19.588 17.413 19.4795L15.4784 17.6089L18.0892 16.9562C18.2406 16.9185 18.2406 16.7034 18.0892 16.6654Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.499 19.2676C13.856 19.2676 14.956 18.1675 14.956 16.8105C14.956 15.4536 13.856 14.3535 12.499 14.3535C11.142 14.3535 10.042 15.4536 10.042 16.8105C10.042 18.1675 11.142 19.2676 12.499 19.2676Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_52845",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTwFlag);
export { ForwardRef as ReactComponent };
